import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { tableApi } from '../../services/api';
import { Table } from '../../types';

interface TablesState {
  items: Table[];
  loading: boolean;
  error: string | null;
}

const initialState: TablesState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchTables = createAsyncThunk(
  'tables/fetchTables',
  async () => {
    const response = await tableApi.getTables();
    return response;
  }
);

export const createTable = createAsyncThunk(
  'tables/createTable',
  async (tableNumber: number) => {
    const response = await tableApi.createTable({ number: tableNumber });
    return response;
  }
);

export const deleteTable = createAsyncThunk(
  'tables/deleteTable',
  async (tableId: number) => {
    await tableApi.deleteTable(tableId);
    return tableId;
  }
);

const tablesSlice = createSlice({
  name: 'tables',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Tables
      .addCase(fetchTables.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTables.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchTables.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch tables';
      })
      // Create Table
      .addCase(createTable.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      // Delete Table
      .addCase(deleteTable.fulfilled, (state, action) => {
        state.items = state.items.filter(table => table.id !== action.payload);
      });
  },
});

export default tablesSlice.reducer; 